import React from 'react';
import AuthModal from './modals/AuthModal';
import { useAuth } from '../contexts/AuthContext';

const GlobalAuthModal: React.FC = () => {
  const { showAuthModal, authModalMode, authModalError, setShowAuthModal } = useAuth();

  const handleClose = () => {
    setShowAuthModal(false);
  };

  const handleModeChange = (mode: 'signin' | 'signup') => {
    setShowAuthModal(true, mode);
  };

  return (
    <AuthModal
      open={showAuthModal}
      onClose={handleClose}
      mode={authModalMode}
      onModeChange={handleModeChange}
      externalError={authModalError}
      showForgotPassword={authModalError !== null} // Show forgot password form when there's an error
    />
  );
};

export default GlobalAuthModal;
